
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class StatusDot extends Vue {
  @Prop(String) readonly width: string | undefined;
}
